export default __webpack_public_path__ + "static/media/static-2.6dc08d23.webp";